document.addEventListener('DOMContentLoaded', () => {
    const container = document.querySelector('.js-marquee');
    if (!container) return;

    const track = container.querySelector('.js-marquee-track');
    let position = 0;
    const speed = 0.7;
    let isDragging = false;
    let lastX = 0;

    function normalizePosition(pos, width) {
        return ((pos % width) + width) % width;
    }

    // Ждем загрузки всех изображений внутри track
    const images = track.querySelectorAll('img');
    const imagesLoaded = Array.from(images).map(img => {
        return new Promise(resolve => {
            if (img.complete) resolve();
            else {
                img.onload = () => resolve();
                img.onerror = () => resolve();
            }
        });
    });

    Promise.all(imagesLoaded).then(() => {
        // Перевіряємо, чи track ширший за container
        if (track.scrollWidth <= container.offsetWidth) {
            container.classList.add('is-not-marquee');
            return;
        }

        // Дублируем содержимое для бесконечной прокрутки
        track.innerHTML += track.innerHTML + track.innerHTML;

        const singleSetWidth = track.scrollWidth / 3;

        function animate() {
            if (!isDragging) {
                position -= speed;
                position = -normalizePosition(-position, singleSetWidth);
            }
            track.style.transform = `translateX(${position}px)`;
            requestAnimationFrame(animate);
        }

        animate();

        container.addEventListener('mousedown', e => {
            isDragging = true;
            lastX = e.clientX;
            container.classList.add('is-dragging');
        });

        document.addEventListener('mousemove', e => {
            if (!isDragging) return;
            const dx = e.clientX - lastX;
            lastX = e.clientX;

            position += dx;
            position = -normalizePosition(-position, singleSetWidth);
            track.style.transform = `translateX(${position}px)`;
        });

        document.addEventListener('mouseup', () => {
            isDragging = false;
            container.classList.remove('is-dragging');
        });

        document.addEventListener('mouseleave', () => {
            isDragging = false;
            container.classList.remove('is-dragging');
        });

        container.addEventListener('touchstart', e => {
            if (e.touches.length !== 1) return;
            isDragging = true;
            lastX = e.touches[0].clientX;
            container.classList.add('is-dragging');
        });

        document.addEventListener('touchmove', e => {
            if (!isDragging || e.touches.length !== 1) return;
            const dx = e.touches[0].clientX - lastX;
            lastX = e.touches[0].clientX;

            position += dx;
            position = -normalizePosition(-position, singleSetWidth);
            track.style.transform = `translateX(${position}px)`;
        });

        document.addEventListener('touchend', () => {
            isDragging = false;
            container.classList.remove('is-dragging');
        });

    });
});